<template>
  <el-container v-title data-title="学校列表" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>学校管理</el-breadcrumb-item>
                <el-breadcrumb-item>学校信息</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="名称">
                  <el-input v-model="searchForm.name" placeholder="名称"></el-input>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getSchoolList">查询</el-button>
                  <el-button type="primary" @click="openAddDialog">新增</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="name" label="名称" width="250"></el-table-column>
          <el-table-column prop="province" label="省" width="100"></el-table-column>
          <el-table-column prop="city" label="市" width="100"></el-table-column>
          <el-table-column prop="district" label="区县" width="100"></el-table-column>
          <el-table-column prop="street" label="镇街" width="100"></el-table-column>
          <el-table-column prop="countOfUser" label="人数" width="100"></el-table-column>
          <el-table-column prop="stopSendForExpiredName" label="是否对欠费学生发送考勤" width="80" v-if="['1'].indexOf(userInfo.userType) != -1"></el-table-column>
          <el-table-column prop="stopVideoPhoneForExpiredName" label="是否停止让欠费学生使用视频电话" width="100" v-if="['1'].indexOf(userInfo.userType) != -1"></el-table-column>
          <el-table-column prop="stopTraditionalPhoneForExpiredName" label="是否停止让欠费学生使用传统电话" width="100" v-if="['1'].indexOf(userInfo.userType) != -1"></el-table-column>
          <el-table-column prop="signInTimeForFaculty" label="上班时间" width="100"></el-table-column>
          <el-table-column prop="signOutTimeForFaculty" label="下班时间" width="100"></el-table-column>
          <el-table-column prop="absenceNoticeSwitchName" label="是否给家长推送未打卡消息" width="80" v-if="['1'].indexOf(userInfo.userType) != -1"></el-table-column>
          <el-table-column prop="telzoneName" label="电话区" width="100" v-if="['1'].indexOf(userInfo.userType) != -1"></el-table-column>
          <el-table-column prop="showStudentCanteenForParentName" label="是否对家长显示学生点餐" width="80" v-if="['1'].indexOf(userInfo.userType) != -1"></el-table-column>
          <el-table-column prop="enableLeaveInStudentCanteenName" label="是否启用学生点餐的请假功能" width="100" v-if="['1'].indexOf(userInfo.userType) != -1"></el-table-column>
          <el-table-column prop="enableStudentCanteenReserveNotifyName" label="是否开启学生未点餐提醒" width="100" v-if="['1'].indexOf(userInfo.userType) != -1"></el-table-column>
          <el-table-column label="操作" width="140">
            <template slot-scope="scope">
              <el-button type="text" @click="openModifyDialog(scope.row)">修改</el-button>
              <el-button type="text" @click="schoolId = scope.row.id; schoolName = scope.row.name; qrcodeDialogVisible = true">天乔二维码</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getSchoolList"
            :current-page.sync="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
      <!-- 弹窗页（修改） -->
      <el-dialog
        title="修改"
        :visible.sync="modifyDialogVisible"
        width="450px"
        :before-close="handleClose">
        <el-form ref="modifyForm" :model="modifyData" :rules="rules" label-width="180px">
          <el-form-item label="名称" :required="true" prop="name">
            <el-input v-model="modifyData.name" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="省" :required="true" prop="province">
            <el-input v-model="modifyData.province" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="市" :required="true" prop="city">
            <el-input v-model="modifyData.city" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="区县" :required="true" prop="district">
            <el-input v-model="modifyData.district" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="镇街" :required="true" prop="street">
            <el-input v-model="modifyData.street" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="是否对欠费学生发送考勤" prop="stopSendForExpired" v-if="['1'].indexOf(userInfo.userType) != -1">
            <el-select v-model="modifyData.stopSendForExpired" placeholder="请选择">
              <el-option label="不停止" value="0"></el-option>
              <el-option label="停止" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否停止让欠费学生使用视频电话" prop="stopVideoPhoneForExpired" v-if="['1'].indexOf(userInfo.userType) != -1">
            <el-select v-model="modifyData.stopVideoPhoneForExpired" placeholder="请选择">
              <el-option label="不停止" value="0"></el-option>
              <el-option label="停止" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否停止让欠费学生使用传统电话" prop="stopTraditionalPhoneForExpired" v-if="['1'].indexOf(userInfo.userType) != -1">
            <el-select v-model="modifyData.stopTraditionalPhoneForExpired" placeholder="请选择">
              <el-option label="不停止" value="0"></el-option>
              <el-option label="停止" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上班时间" :required="true" prop="signInTimeForFaculty">
            <el-time-select
              v-model="modifyData.signInTimeForFaculty"
              :picker-options="{start:'00:00',step:'00:05',end:'23:59'}"
              placeholder="上班时间" style="width: 180px">
            </el-time-select>
          </el-form-item>
          <el-form-item label="下班时间" :required="true" prop="signOutTimeForFaculty">
            <el-time-select
              v-model="modifyData.signOutTimeForFaculty"
              :picker-options="{start:'00:00',step:'00:05',end:'23:59'}"
              placeholder="下班时间" style="width: 180px">
            </el-time-select>
          </el-form-item>
          <el-form-item label="是否给家长推送未打卡消息" prop="absenceNoticeSwitch" v-if="['1'].indexOf(userInfo.userType) != -1">
            <el-select v-model="modifyData.absenceNoticeSwitch" placeholder="请选择">
              <el-option label="不推送" value="0"></el-option>
              <el-option label="推送" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="电话区" prop="telzoneId">
            <el-select v-model="modifyData.telzoneId">
              <el-option v-for="(item, index) in telzoneList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否对家长显示学生点餐" prop="showStudentCanteenForParent" v-if="['1'].indexOf(userInfo.userType) != -1">
            <el-select v-model="modifyData.showStudentCanteenForParent" placeholder="请选择">
              <el-option label="不显示" value="0"></el-option>
              <el-option label="显示" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否启用学生点餐的请假功能" prop="enableLeaveInStudentCanteen" v-if="['1'].indexOf(userInfo.userType) != -1">
            <el-select v-model="modifyData.enableLeaveInStudentCanteen" placeholder="请选择">
              <el-option label="不启用" value="0"></el-option>
              <el-option label="启用" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否开启学生未点餐提醒" prop="enableStudentCanteenReserveNotify" v-if="['1'].indexOf(userInfo.userType) != -1">
            <el-select v-model="modifyData.enableStudentCanteenReserveNotify" placeholder="请选择">
              <el-option label="不启用" value="0"></el-option>
              <el-option label="启用" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="modifySchool">修改</el-button>
            <el-button @click="modifyDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 弹窗页（新增） -->
      <el-dialog
        title="新增"
        :visible.sync="addDialogVisible"
        width="450px"
        :before-close="handleClose">
        <el-form ref="addForm" :model="addData" :rules="rules" label-width="180px">
          <el-form-item label="名称" :required="true" prop="name">
            <el-input v-model="addData.name" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="省" :required="true" prop="province">
            <el-input v-model="addData.province" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="市" :required="true" prop="city">
            <el-input v-model="addData.city" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="区县" :required="true" prop="district">
            <el-input v-model="addData.district" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="镇街" :required="true" prop="street">
            <el-input v-model="addData.street" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="是否对欠费学生发送考勤" prop="stopSendForExpired" v-if="['1'].indexOf(userInfo.userType) != -1">
            <el-select v-model="addData.stopSendForExpired" placeholder="请选择">
              <el-option label="不停止" value="0"></el-option>
              <el-option label="停止" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否停止让欠费学生使用视频电话" prop="stopVideoPhoneForExpired" v-if="['1'].indexOf(userInfo.userType) != -1">
            <el-select v-model="addData.stopVideoPhoneForExpired" placeholder="请选择">
              <el-option label="不停止" value="0"></el-option>
              <el-option label="停止" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否停止让欠费学生使用传统电话" prop="stopTraditionalPhoneForExpired" v-if="['1'].indexOf(userInfo.userType) != -1">
            <el-select v-model="addData.stopTraditionalPhoneForExpired" placeholder="请选择">
              <el-option label="不停止" value="0"></el-option>
              <el-option label="停止" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上班时间" :required="true" prop="signInTimeForFaculty">
            <el-time-select
              v-model="addData.signInTimeForFaculty"
              :picker-options="{start:'00:00',step:'00:05',end:'23:59'}"
              placeholder="上班时间" style="width: 180px">
            </el-time-select>
          </el-form-item>
          <el-form-item label="下班时间" :required="true" prop="signOutTimeForFaculty">
            <el-time-select
              v-model="addData.signOutTimeForFaculty"
              :picker-options="{start:'00:00',step:'00:05',end:'23:59'}"
              placeholder="下班时间" style="width: 180px">
            </el-time-select>
          </el-form-item>
          <el-form-item label="是否给家长推送未打卡消息" prop="absenceNoticeSwitch" v-if="['1'].indexOf(userInfo.userType) != -1">
            <el-select v-model="addData.absenceNoticeSwitch" placeholder="请选择">
              <el-option label="不推送" value="0"></el-option>
              <el-option label="推送" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="电话区" prop="telzoneId">
            <el-select v-model="addData.telzoneId">
              <el-option v-for="(item, index) in telzoneList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否对家长显示学生点餐" prop="showStudentCanteenForParent" v-if="['1'].indexOf(userInfo.userType) != -1">
            <el-select v-model="addData.showStudentCanteenForParent" placeholder="请选择">
              <el-option label="不显示" value="0"></el-option>
              <el-option label="显示" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否启用学生点餐的请假功能" prop="enableLeaveInStudentCanteen" v-if="['1'].indexOf(userInfo.userType) != -1">
            <el-select v-model="addData.enableLeaveInStudentCanteen" placeholder="请选择">
              <el-option label="不启用" value="0"></el-option>
              <el-option label="启用" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否开启学生未点餐提醒" prop="enableStudentCanteenReserveNotify" v-if="['1'].indexOf(userInfo.userType) != -1">
            <el-select v-model="addData.enableStudentCanteenReserveNotify" placeholder="请选择">
              <el-option label="不启用" value="0"></el-option>
              <el-option label="启用" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addSchool">新增</el-button>
            <el-button @click="addDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog
          :title="schoolName"
          :visible.sync="qrcodeDialogVisible"
          width="400px"
          height="400px"
          :before-close="handleClose"
          @opened="generateQrCode"
          @close="clearQrCode">
        <div id="qrcode" v-show="qrcodeVisible"></div>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
import QRCodeJs2 from 'qrcodejs2'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {},
      modifyData: {},
      modifyDialogVisible: false,
      addData: {},
      addDialogVisible: false,
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        province: [{ required: true, message: '请输入省', trigger: 'blur' }],
        city: [{ required: true, message: '请输入市', trigger: 'blur' }],
        district: [{ required: true, message: '请输入区县', trigger: 'blur' }],
        street: [{ required: true, message: '请输入镇街', trigger: 'blur' }]
      },
      telzoneList: [],
      qrcode: null,
      qrcodeDialogVisible: false,
      qrcodeVisible: true,
      schoolId: null,
      schoolName: null
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
      this.getTelzoneList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getSchoolList()
    },
    openModifyDialog (schoolData) {
      this.modifyData = JSON.parse(JSON.stringify(schoolData))
      this.modifyDialogVisible = true
    },
    modifySchool () {
      let _this = this
      this.$refs['modifyForm'].validate((valid) => {
        if (valid) {
          this.$axios.post(this.GLOBAL.host + '/school/update',
            _this.modifyData
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.modifyDialogVisible = false
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                _this.getSchoolList()
                this.$refs['modifyForm'].resetFields()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    openAddDialog () {
      this.addDialogVisible = true
    },
    addSchool () {
      let _this = this
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          this.$axios.post(this.GLOBAL.host + '/school/add',
            _this.addData
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.addDialogVisible = false
                _this.addData = {}
                this.$message({
                  message: '新增成功',
                  type: 'success'
                })
                _this.getSchoolList()
                _this.$refs['addForm'].resetFields()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getSchoolList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          name: _this.searchForm.name,
          page: _this.currentPage,
          size: _this.pageSize
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    getTelzoneList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/telzone/list').then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.telzoneList = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    generateQrCode () {
      let _this = this
      if (this.qrcode != null) {
        _this.qrcode.makeCode('https://wx.hzjxaf.com/#/faceUploadTemp?schoolId=' + _this.schoolId)
        _this.qrcodeVisible = true
      } else {
        this.qrcode = new QRCodeJs2('qrcode', {
          text: 'https://wx.hzjxaf.com/#/faceUploadTemp?schoolId=' + _this.schoolId,
          width: 360,
          height: 360,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCodeJs2.CorrectLevel.H
        })
      }
    },
    clearQrCode () {
      if (this.qrcode != null) {
        this.qrcode.clear()
        this.qrcodeVisible = false
      }
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/School.vue